"use strict";

var bidder = bidder || {};

bidder.LANGUAGE_DEFAULT = "it";
bidder.COUNTRY_DEFAULT = "IT";
bidder.CURRENCY_CODE_DEFAULT = "EUR";
bidder.CURRENCY_SYMBOL_DEFAULT = "€";
bidder.BOOL_TRUE = "True";
bidder.BOOL_FALSE = "False";

bidder.CURRENCY_CODE = bidder.CURRENCY_CODE_DEFAULT;
bidder.CURRENCY_SYMBOL = bidder.CURRENCY_SYMBOL_DEFAULT;

bidder.AuctionStatus = {
    Draft: { value: 70, name: "draft" },
    Published: { value: 71, name: "published" },
};

bidder.SessionStatus = {
    Draft: { value: 110, name: "draft" },
    Ready: { value: 111, name: "ready" },
    Live: { value: 112, name: "live" },
    Closed: { value: 113, name: "closed" },
};

bidder.LotStatus = {
    Sellable: { value: 80, name: "sellable" },
    Sold: { value: 81, name: "sold" },
    Unsold: { value: 82, name: "unsold" },
    Retired: { value: 83, name: "retired" },
    NoData: { value: 84, name: "nodata" },
    Join: function () {
        return bidder.LotStatus.Sellable.name + " " +
            bidder.LotStatus.Sold.name + " " +
            bidder.LotStatus.Unsold.name + " " +
            bidder.LotStatus.Retired.name + " " +
            bidder.LotStatus.NoData.name;
    }, 
    findByValue: function (value) {
        return bidder.findByValue(bidder.LotStatus, value);
    }
};

bidder.OfferChannel = {
    Web: { value: 250, name: "web" },
    Hall: { value: 251, name: "hall" },
    Email: { value: 252, name: "email" },
    Phone: { value: 253, name: "phone" },
};

bidder.OfferType = {
    Auction: { value: 90, name: "auction" },
    Presales: { value: 91, name: "presales" },
    FreeOffer: { value: 92, name: "freeoffer" },
};

bidder.BidderType = {
    Bidder: { value: 100, name: "Bidder" },
    House: { value: 101, name: "House" },
    None: { value: 102, name: "None" },
};

bidder.UserAuthStatus = {
    None: { value: 0, name: "None" },
    Pending: { value: 1, name: "Pending" },
    Accepted: { value: 2, name: "Accepted" },
    Reject: { value: 3, name: "Reject" },
    Suspended: { value: 4, name: "Suspended" },
};

bidder.ButtonStyle = {
    Disabled: { name: "btn-offer-disabled" },
    Enabled: { name: "btn-offer-enabled" },
    Best: { name: "btn-offer-best" },
    Winner: { name: "btn-offer-winner" },    
    FairWarning: { name: '-fair-warning' },
    Join: function () {
        return bidder.ButtonStyle.Disabled.name + " " +
            bidder.ButtonStyle.Enabled.name + " " +
            bidder.ButtonStyle.Best.name + " " +
            bidder.ButtonStyle.FairWarning.name + ' ' +
            bidder.ButtonStyle.Winner.name;
    }
};

bidder.HistMsgType = {
    NewLot: { name: "msg-new" },
    Warning: { name: "msg-warning" },
    MyOffer: { name: "msg-your-offer" },
    Offer: { name: "msg-offer" },
    LotSold: { name: "msg-sold" },
    LotUnsold: { name: "msg-unsold" },
    Normal: { name: "msg-info" },
    Overtaken: { name: 'msg-overtaken' },
    //Reopen: { name: "msg-alert" },
    Join: function () {
        return bidder.HistMsgType.NewLot.name + " " +
            bidder.HistMsgType.Warning.name + " " +
            bidder.HistMsgType.MyOffer.name + " " +
            bidder.HistMsgType.Offer.name + " " +
            bidder.HistMsgType.LotSold.name + " " +
            bidder.HistMsgType.LotUnsold.name + " " +
            bidder.HistMsgType.Overtaken.name + " " +
            bidder.HistMsgType.Normal.name;
    }
};

bidder.LogType = {
    Debug: { name: "debug" },
    Error: { name: "error" },
    Info: { name: "info" },
    Warning: { name: "warning" },
    Success: { name: "success" },
    Join: function () {
        return bidder.LogType.Error.name + " " +
            bidder.LogType.Info.name + " " +
            bidder.LogType.Warning.name + " " +
            bidder.LogType.Success.name;
    }
};

bidder.ConnectionStatus = {
    Connecting: { value: 0, name: "connecting" },
    Connected: { value: 1, name: "connected" },
    Reconnecting: { value: 2, name: "reconnecting" },
    Disconnected: { value: 4, name: "disconnected" },
};

bidder.findByValue = function (list, value) {
    for (var key in list) {
        if (list[key].value == value) {
            return list[key];
        }
    }
}